import { EnumProcessorSchedulingStatus } from 'lib/graphql';

/**
 * Form values for cancelling a booking
 */
export interface CancelBookingFormValues {
  reason: string;
  details: string;
}

/**
 * Statuses that allow job cancellation
 */
export const CANCELLABLE_STATUSES = [
  EnumProcessorSchedulingStatus.Initial,
  EnumProcessorSchedulingStatus.Requested,
  EnumProcessorSchedulingStatus.Scheduled,
  EnumProcessorSchedulingStatus.DroppedOff,
  EnumProcessorSchedulingStatus.Killed,
  EnumProcessorSchedulingStatus.Aging,
  EnumProcessorSchedulingStatus.Curing,
];

/**
 * Statuses that allow cutsheet editing
 */
export const CUTSHEET_STATUSES = [
  EnumProcessorSchedulingStatus.DroppedOff,
  EnumProcessorSchedulingStatus.Requested,
  EnumProcessorSchedulingStatus.Scheduled,
  EnumProcessorSchedulingStatus.Killed,
  EnumProcessorSchedulingStatus.Aging,
  EnumProcessorSchedulingStatus.Curing,
];

export const renderStatusText = (statusValue: string) => {
  switch (statusValue) {
    case EnumProcessorSchedulingStatus.Requested:
    case EnumProcessorSchedulingStatus.Initial:
      return 'Requested';
    case EnumProcessorSchedulingStatus.Scheduled:
      return 'Scheduled';
    case EnumProcessorSchedulingStatus.MissedDropOff:
      return 'Missed Drop Off';
    case EnumProcessorSchedulingStatus.DroppedOff:
      return 'Dropped Off';
    case EnumProcessorSchedulingStatus.Killed:
      return 'Harvested';
    case EnumProcessorSchedulingStatus.Aging:
      return 'Aging';
    case EnumProcessorSchedulingStatus.Curing:
      return 'Curing';
    case EnumProcessorSchedulingStatus.Invoicing:
      return 'Invoicing';
    case EnumProcessorSchedulingStatus.ReadyPayAtPickup:
      return 'Ready for Pickup';
    case EnumProcessorSchedulingStatus.InvoicePaid:
      return 'Invoice Paid';
    case EnumProcessorSchedulingStatus.Completed:
      return 'Completed';
    case EnumProcessorSchedulingStatus.CancelledByProcessor:
      return 'Cancelled by Processor';
    case EnumProcessorSchedulingStatus.CancelledByProducer:
      return 'Cancelled by Producer';
    case EnumProcessorSchedulingStatus.DepositFailed:
      return 'Deposit Failed';
    case EnumProcessorSchedulingStatus.CheckoutExpired:
      return 'Checkout Expired';
    case EnumProcessorSchedulingStatus.DeniedByProcessor:
      return 'Denied';
    default:
      return 'Unknown';
  }
};

export enum EnumProcessorStatusGroups {
  Requested = 'Requested',
  Scheduled = 'Scheduled',
  In_Progress = 'In Progress',
  Completed = 'Completed',
}

export const ALL_SHOWN_STATUSES = [
  EnumProcessorSchedulingStatus.Requested,
  EnumProcessorSchedulingStatus.Scheduled,
  EnumProcessorSchedulingStatus.DroppedOff,
  EnumProcessorSchedulingStatus.Killed,
  EnumProcessorSchedulingStatus.Aging,
  EnumProcessorSchedulingStatus.Curing,
  EnumProcessorSchedulingStatus.Invoicing,
  EnumProcessorSchedulingStatus.ReadyPayAtPickup,
  EnumProcessorSchedulingStatus.InvoicePaid,
  EnumProcessorSchedulingStatus.Completed,
  EnumProcessorSchedulingStatus.MissedDropOff,
];

export const IN_PROGRESS_STATUSES = [
  EnumProcessorSchedulingStatus.DroppedOff,
  EnumProcessorSchedulingStatus.Killed,
  EnumProcessorSchedulingStatus.Aging,
  EnumProcessorSchedulingStatus.Curing,
  EnumProcessorSchedulingStatus.Invoicing,
  EnumProcessorSchedulingStatus.InvoicePaid,
  EnumProcessorSchedulingStatus.ReadyPayAtPickup,
  EnumProcessorSchedulingStatus.Scheduled,
];

export const COMPLETED_STATUSES = [
  EnumProcessorSchedulingStatus.MissedDropOff,
  EnumProcessorSchedulingStatus.Completed,
  EnumProcessorSchedulingStatus.CancelledByProcessor,
  EnumProcessorSchedulingStatus.CancelledByProducer,
  EnumProcessorSchedulingStatus.DepositFailed,
  EnumProcessorSchedulingStatus.CheckoutExpired,
  EnumProcessorSchedulingStatus.DeniedByProcessor,
];

export const getStatusColor = (statusValue: string) => {
  switch (statusValue) {
    case EnumProcessorSchedulingStatus.Requested:
    case EnumProcessorSchedulingStatus.Initial:
      return 'statusRequested.main';

    case EnumProcessorSchedulingStatus.Scheduled:
      return 'statusScheduled.main';

    case EnumProcessorSchedulingStatus.DroppedOff:
    case EnumProcessorSchedulingStatus.Killed:
    case EnumProcessorSchedulingStatus.Aging:
    case EnumProcessorSchedulingStatus.Curing:
    case EnumProcessorSchedulingStatus.Invoicing:
    case EnumProcessorSchedulingStatus.ReadyPayAtPickup:
    case EnumProcessorSchedulingStatus.InvoicePaid:
      return 'statusInProgress.main';

    case EnumProcessorSchedulingStatus.MissedDropOff:
    case EnumProcessorSchedulingStatus.Completed:
    case EnumProcessorSchedulingStatus.CancelledByProcessor:
    case EnumProcessorSchedulingStatus.CancelledByProducer:
    case EnumProcessorSchedulingStatus.DepositFailed:
    case EnumProcessorSchedulingStatus.CheckoutExpired:
    case EnumProcessorSchedulingStatus.DeniedByProcessor:
      return 'statusCompleted.main';

    default:
      return 'statusCompleted.main';
  }
};

export const getGroupColor = (statusValue: string) => {
  switch (statusValue) {
    case EnumProcessorStatusGroups.Requested:
      return 'statusRequested.main';

    case EnumProcessorStatusGroups.Scheduled:
      return 'statusScheduled.main';

    case EnumProcessorStatusGroups.In_Progress:
      return 'statusInProgress.main';

    case EnumProcessorStatusGroups.Completed:
      return 'statusCompleted.main';

    default:
      return 'statusCompleted.main';
  }
};
